import BaseService from '@/ecm/common/BaseService.js';

class SearchService {
  baseUrl = 'search';

  getDocuments = (documentIds) => BaseService.post({ url: `${this.baseUrl}/search-objects/${documentIds}` });
  getAdvSearchFields = (contentTypeIDs, removeNonVisibleFields = true) => {
    let normalizedIds = [];
    if (Array.isArray(contentTypeIDs)) {
        normalizedIds = contentTypeIDs.map(id => parseInt(id, 10));
    } else {
        const singleId = parseInt(contentTypeIDs, 10);
        if (!isNaN(singleId)) {
            normalizedIds = [singleId];
        }
    }
    const request = {
        ContentTypeIds: normalizedIds
    };
    if (removeNonVisibleFields) {
        return BaseService.post({ url: `${this.baseUrl}/fields`, data: request });
    } else {
        return BaseService.post({ url: `${this.baseUrl}/fields-for-rights`, data: request });
    }
  };

  getSearchResults = (searchRequest) => BaseService.post({ url: `${this.baseUrl}/get-search-results`, data: searchRequest });
  saveUserSearch = (userSearch) => BaseService.post({ url: `${this.baseUrl}/save-user-search`, data: userSearch });
  getDocumentsByCriteria = (searchRequest) => BaseService.post({ url: `${this.baseUrl}/get-document-by-criteria`, data: searchRequest });
  getUserSearchDocumentCount = (dashboardItemDTO) => BaseService.post({ url: `${this.baseUrl}/get-user-search-document-count`, data: dashboardItemDTO });
  invalidateCacheForVariableChanges = (variableId) => BaseService.post({ url: `${this.baseUrl}/invalidate-cache-for-variable-changes/${variableId}` });
}

export default new SearchService();
